import campaignsActionTypes from './action-types';

export const fetchCampaignsList = payload => ({
  type: campaignsActionTypes.FETCH_CAMPAIGNS_LIST,
  payload,
});

export const fetchCampaignsListSuccess = payload => ({
  type: campaignsActionTypes.FETCH_CAMPAIGNS_LIST_SUCCESS,
  payload,
});

export const fetchCampaignsListFail = payload => ({
  type: campaignsActionTypes.FETCH_CAMPAIGNS_LIST_FAIL,
  payload,
});

export const fetchCampaignInfo = payload => ({
  type: campaignsActionTypes.FETCH_CAMPAIGN_INFO,
  payload,
});

export const fetchCampaignInfoSuccess = payload => ({
  type: campaignsActionTypes.FETCH_CAMPAIGN_INFO_SUCCESS,
  payload,
});

export const fetchCampaignInfoFail = payload => ({
  type: campaignsActionTypes.FETCH_CAMPAIGN_INFO_FAIL,
  payload,
});

export const fetchAddOrEditCampaignSubmission = payload => ({
  type: campaignsActionTypes.FETCH_ADD_OR_EDIT_CAMPAIGN_SUBMISSION,
  payload,
});

export const fetchAddOrEditCampaignSubmissionSuccess = payload => ({
  type: campaignsActionTypes.FETCH_ADD_OR_EDIT_CAMPAIGN_SUBMISSION_SUCCESS,
  payload,
});

export const fetchAddOrEditCampaignSubmissionFail = payload => ({
  type: campaignsActionTypes.FETCH_ADD_OR_EDIT_CAMPAIGN_SUBMISSION_FAIL,
  payload,
});

export const setCampaignDetails = payload => ({
  type: campaignsActionTypes.SET_CAMPAIGN_DETAILS,
  payload,
});
